/**
 * @author jzetlen
 * Apr 22 2016
 * Decorates a Backbone.Collection with prefetching behavior; the collection
 * will decorate some subset of its models with a prefetching `sync` method
 * that caches the initial server response to a model#sync('read') call.
 * @param {Backbone.Collection} collectionConstructor - the Backbone.Collection
 *        constructor to decorate
 * @param {Function} prefetchSelector - a function that returns an array of
 *        Backbone.Models to prefetch
 * @return {Backbone.Collection} a prefetching collection
 */
import { wrap } from 'underscore';
export default function prefetches(collectionConstructor, prefetchSelector) {
	const proto = collectionConstructor.prototype;
	if (!proto.__prefetches) {
		proto.__prefetches = true; // flag so we do not nest prefetches
		/**
		 * the `prefetch` selector receives JSON data, runs in the context of
		 * the collection as `this`, and is expected to return an array of
		 * Backbone.Model instances, each with a `sync` method.
		 *
		 * the default implementation simply returns the first model.
		 **/
		proto._prefetchSelector = prefetchSelector || function(data) {
				return this.slice(0, 1);
			};

		/**
		 * override the `set` method used to populate initial data.
		 */
		proto.set = wrap(proto.set, function prefetchSet(set, data, ...args) {
			const setReturnValue = set.apply(this, [data, ...args]);
			this._prefetchSelector(data).forEach((item) => {
				if (!item.__prefetches) {
					item.__prefetches = true; // flag so we do not repeat this

					/**
					 * perform the initial read
					 */
					item.sync('read', item, {

						/**
						 * signal to the prefetch manager decorating
						 * Backbone.sync that this is a prefetch to be stored
						 */
						prefetch: true
					});
				}
			});
			return setReturnValue;
		});
	}
	return collectionConstructor;
}



// WEBPACK FOOTER //
// ./lib/prefetch-decorator.es6